import { render, staticRenderFns } from "./HeaderToken.vue?vue&type=template&id=046ef522&"
import script from "./HeaderToken.vue?vue&type=script&lang=js&"
export * from "./HeaderToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports